import React from 'react';
import { UnifyHandoff } from './unify-handoff/unify-handoff';
import { HandoffEditPage } from './handoff-edit-page';
import { HandoffFlowProps } from './handoff-flow.types';

export const UnifyHandoffFlow = ({
  snapshot,
  isUpdating,
  onCancel,
  navigateToRoot,
  siblingLocations,
  typeSelector,
}: HandoffFlowProps) => (
  <HandoffEditPage snapshot={snapshot} isUpdating={isUpdating}>
    {typeSelector}
    <UnifyHandoff
      onCancel={onCancel}
      // Save and submit snapshot is handled in UnifyHandoff itself.
      onSaveAndClose={navigateToRoot}
      onSubmit={navigateToRoot}
      locationsList={siblingLocations}
      handoffGroupId={snapshot.groupId}
    />
  </HandoffEditPage>
);
